import { inject, Injectable, PLATFORM_ID } from '@angular/core';
import { LOCAL_STORAGE, ROLE } from '../../../models/constant/constants';
import { Observable, of, Subject } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { isPlatformServer } from '@angular/common';

@Injectable({
  providedIn: 'root'
})
export class StorageService {
  httpClient = inject(HttpClient);
  private platformId = inject(PLATFORM_ID);

  change = new Subject();
  onChange = this.change.asObservable();
  getUserData(key:string):string{
    if(isPlatformServer(this.platformId)) {
      return "null";
    } 
    return (localStorage.getItem(key) || sessionStorage.getItem(key)) || 'null';
  }

  /**
   * Check if user enbaled stay signed in enable during login
   * @returns true if stay signed in was checked during login
   */
  getPersistentSignedIn(): boolean {
    return JSON.parse(this.getUserData(LOCAL_STORAGE.STAY_LOGGED_IN));
  }

  setUserData(key: string, userData: string, staySignedIn: boolean): void {
    if(isPlatformServer(this.platformId)) {
      console.log("Set storage data on server side");
      return;
    } 
    staySignedIn ? localStorage.setItem(key, userData) : sessionStorage.setItem(key, userData);
  }

  getRole():Observable<ROLE> {
    const data = JSON.parse(this.getUserData(LOCAL_STORAGE.USER_DETAILS)) || {};

    return of(data?.role);
  }

  getArtistId():string | number{
    const userData = JSON.parse(this.getUserData('userData') || "null");
    if (!userData?.artistProfileId) {
      return '';
    }
    return userData?.artistProfileId;
  }

  getUserId():number | null{
    const userData = JSON.parse(this.getUserData('userData') || "null");
    if (!userData?.userId) {
      return null;
    }
    return userData?.userId || null;
  }

  getCountries(): Observable<any> {
    return this.httpClient.get('/assets/json/countries.json', {
      headers: new HttpHeaders({
        'Cache-Control': 'no-cache, no-store, must-revalidate',
        'Pragma': 'no-cache',
        'Expires': '0',
      })
    });
  }
}
